import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegisterRequest } from '../models/register.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apiPath = '';

  constructor(private httpClient: HttpClient) {
  }

  set path(value: string) {
    this.apiPath = value;
  }

  register(data: RegisterRequest): Observable<unknown> {
    return this.httpClient.post(`${environment.apiUrl}${this.apiPath}/users`, data);
  }
}